import m0boot from './m0-boot.json';
import m1drift from './m1-drift.json';
import m2wall from './m2-wall.json';
import m3lap from './m3-lap.json';
import m3free from './m3-free.json';
import m3hug from './m3-hug.json';
import m3stadium from './m3-stadium.json';
import m3bus from './m3-bus.json';
import m4grid from './m4-grid.json';
import { buildRace, buildPack } from './race';
import type { Scenario } from './types';

/** Registre des scénarios. Exposé en mode test via window.__scenarios. */
export const SCENARIOS: Record<string, Scenario> = {
  'm0-boot': m0boot as Scenario,
  'm1-drift': m1drift as Scenario,
  'm2-wall': m2wall as Scenario,
  'm3-lap': m3lap as Scenario,
  'm3-free': m3free as Scenario,
  'm3-hug': m3hug as Scenario,
  'm3-stadium': m3stadium as Scenario,
  'm3-bus': m3bus as Scenario,
  'm4-grid': m4grid as Scenario,
  'm4-complex': buildRace('complex', 'car'), // course sur le circuit technique (joueur + 4 IA)
  'm5-pack': buildPack('stadium', 8), // peloton dense de 8 IA (évitement + dépassements)
  'm5-pack-complex': buildPack('complex', 8), // idem sur le circuit technique
};

/** Scénario initial du harness. */
export const DEFAULT_SCENARIO: Scenario = SCENARIOS['m0-boot'];

/** Scénario chargé au lancement du jeu réel (circuit + conduite clavier). */
export const LIVE_SCENARIO: Scenario = SCENARIOS['m3-stadium'];
